module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-wrapper"><div class="dialog modal-dialog dialog-edu-global"><div class="dialog-mask"></div><div class="dialog-main"><button class="vertical-a iconfont icon-close close-edu-global">x</button><div class="dialog-body"><div class="add-form-dialog-body"><div class="title">교육전문가 자격증 신청</div><div class="body"><p>다음 자료 및 정보를 준비하고 무료로 교육 전문가 으로 업그레이드하려면 support@umu.com으로 UMU에 문의하십시오.</p><p>1. 등록된 UMU 계정 정보(사용자 이름, 이메일 또는 휴대폰 번호 정보).</p><p>2. 현직교원 재직증명서 또는 기타 본인임을 증명할 수 있는 재직증명서</p></div><div class="footer"><button class="btn-confirm close-edu-global">이해했다</button></div></div></div></div></div></div>\n';

}
return __p
}